"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bootstrap_1 = require("bootstrap");
var constants_1 = require("../data/constants");
var CollapseItems = /** @class */ (function () {
    function CollapseItems() {
        var _a;
        this.collapseItems = document.querySelectorAll("[".concat(constants_1.DATA_COLLAPSE_ITEM, "]"));
        if (!this.collapseItems) {
            return;
        }
        (_a = this.collapseItems) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            new bootstrap_1.Collapse(item, {
                toggle: false,
            });
        });
    }
    return CollapseItems;
}());
exports.default = CollapseItems;
